import { render } from "./App.vue?vue&type=template&id=4f09dcb8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4f09dcb8&lang=scss"
script.render = render

export default script